import ax from "axios";
import Vue from "vue";
import { ir } from "./check_domain_ir";
import JwtService from "@/core/services/jwt.service";
import { LOGOUT } from "@/core/services/store/auth.module";

export const axios = ax.create();
window.axios = axios;

axios.interceptors.response.use(
  (response) => {
    try {
      response.data = window.Vue.$responseTranslate(response.data);
    } catch (e) {}
    return response;
  },
  (response) => {
    try {
      response.response.data = window.Vue.$responseTranslate(
        response.response.data
      );
    } catch (e) {}
    return Promise.reject(response);
  }
);

const CoreAPIUrl = ir(process.env.VUE_APP_CoreLandUrl);
const CoreSecret = process.env.VUE_APP_CoreSecret;
const APIUrl = ir(process.env.VUE_APP_API_URL);
const invite = ir(process.env.VUE_APP_robot);

function checkToken(token) {
  axios
    .get(`${CoreAPIUrl}/api/user`, {
      headers: {
        secret: CoreSecret,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem("user_info", JSON.stringify(res.data));
        // this.$router.push({name: 'dashboard'})
      }
    })
    .catch(({ response }) => {
      if (response.status === 401) {
        this.$store
          .dispatch(LOGOUT)
          .then(() => window.location.replace(`${this.$sarveLandFront}`));
      }
    });
}

function saveToken(token) {
  localStorage.setItem("id_token", token);
  this.$router.push("/dashboard");
}

function inviteHeader() {
  return {
    Authorization: Token || null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function header() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function coreHeader() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    secret: CoreSecret,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function requestApiGet(uri, queries = {}) {
  return axios.get(`${APIUrl + "/api"}/${uri}`, {
    headers: this.header(),
    params: queries,
  });
}
function requestInvite(uri, queries = {}) {
  return axios.get(`${invite + "/api"}/${uri}`, {
    headers: this.inviteHeader(),
    params: queries,
  });
}

function requestApiGetCore(uri, queries = {}) {
  return axios.get(`${CoreAPIUrl + "/api"}/${uri}`, {
    headers: this.coreHeader(),
    params: queries,
  });
}
function requestApiPostCore(uri, data = {}) {
  return axios.post(`${CoreAPIUrl + "/api"}/${uri}`, data, {
    headers: this.coreHeader(),
  });
}

function requestApiPost(uri, data = {}) {
  return axios.post(`${APIUrl + "/api"}/${uri}`, data, {
    headers: this.header(),
  });
}

function requestApiPostLogin(uri, data = {}) {
  return axios.post(`${APIUrl + "/api"}/${uri}`, data);
}

function requestApiPut(uri, data = {}, queries = {}) {
  return axios.put(`${APIUrl + "/api"}/${uri}`, data, {
    headers: this.header(),
    params: queries,
  });
}

function requestApiDelete(uri, queries = {}) {
  return axios.delete(`${APIUrl + "/api"}/${uri}`, {
    headers: this.header(),
    params: queries,
  });
}

export default {
  saveToken,
  checkToken,
  header,
  coreHeader,
  inviteHeader,
  requestApiGet,
  requestApiPost,
  requestApiPostCore,
  requestApiPostLogin,
  requestApiPut,
  requestApiDelete,
  requestApiGetCore,
  requestInvite,
};
